export enum StatusType {
  Operational = 'operational',
  Under_Maintenance = 'under_maintenance',
  Degraded_Performance = 'degraded_performance',
  Partial_Outage = 'partial_outage',
  Major_Outage = 'major_outage',
}

export interface AppStatus {
  id: string;
  name: string;
  status: StatusType;
}

export interface Maintenance {
  components: AppStatus[];
  scheduled_for: string;
  scheduled_until: string;
}
